import Logo from '../components/Logo';

export default function ErrorPage({ code = '404', title, message, ctaLabel = 'Go to sign in', ctaHref = '#/login' }) {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.brandRow}>
          <Logo width={180} style={{ margin: '0 auto' }} />
          <div style={styles.sub}>Owner Portal</div>
        </div>

        <div style={styles.code}>{code}</div>
        <h1 style={styles.title}>{title}</h1>
        <p style={styles.message}>{message}</p>

        <a href={ctaHref} style={styles.button}>{ctaLabel}</a>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--cream)', padding: '20px' },
  card: { backgroundColor: 'var(--white)', borderRadius: '12px', padding: '48px 44px', width: '100%', maxWidth: '460px', boxShadow: 'var(--shadow-card)', border: '1px solid var(--gray-100)', textAlign: 'center' },
  brandRow: { textAlign: 'center', marginBottom: '28px' },
  sub: { fontSize: '10px', color: 'var(--gray-400)', textTransform: 'uppercase', letterSpacing: '0.14em', marginTop: '6px', fontWeight: 500 },
  code: { fontSize: '56px', fontWeight: 700, color: 'var(--teal)', letterSpacing: '-0.03em', lineHeight: 1, marginBottom: '8px' },
  title: { fontSize: '22px', fontWeight: 700, color: 'var(--navy)', margin: '0 0 10px 0', letterSpacing: '-0.01em' },
  message: { fontSize: '14px', color: 'var(--gray-600)', margin: '0 0 28px 0', lineHeight: 1.5 },
  button: { display: 'inline-block', backgroundColor: 'var(--navy)', color: 'var(--white)', border: 'none', borderRadius: '6px', padding: '11px 28px', fontSize: '14px', fontWeight: 500, textDecoration: 'none', boxShadow: '0 2px 8px rgba(19,33,57,0.22)' }
};
